import { useRemoteStrings } from '@acorns/web-utils'

import { useEarnDropsCohortEligibilityQuery } from 'generated/types'
import { isSafari as checkIsSafari } from 'utils/browser/detection'
import { Platform, getPlatform } from 'utils/device/detection'

export const useDisplaySafariExtensionCard = () => {
  const { getRemoteString } = useRemoteStrings()

  const isDesktop = getPlatform() === Platform.Desktop
  const isSafari = checkIsSafari()

  const cohortName = getRemoteString({
    key: 'earn.extension.cohort_name.safari',
  })

  const { data, loading } = useEarnDropsCohortEligibilityQuery({
    fetchPolicy: 'network-only',
    skip: !isSafari || !isDesktop,
    variables: {
      cohort: cohortName,
    },
  })

  const hasSafariExtensionInstalled = !data?.cohortEligibility_v2[0].eligible

  return {
    showSafariCard: !hasSafariExtensionInstalled,
    loading,
  }
}
